// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NavBar */

header{
    width: 100%;
    height: 6rem;
    position: fixed;
    z-index: 10;
    box-shadow: 0px 0px 5px 1px var(--box-shadow-high);
    background: var(--white);
}

.nav-bar{
    height: 100%;
    margin: auto;
    max-width: 1680px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 10%;
    font-size: 1rem;
}

.nav-links{
    display: flex;
}

.navbar-logos{
    display: flex;
    justify-content: center;
    align-items: center;
}

header .nav-bar ul{
    height: 100%;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;
    padding: 0px;
}

header .nav-bar li{
    text-align: center;
}

.logo-sensedia, .logo-support-premium{
    height: 3.2em;
    margin-right: 4em;
}

.logo-support-premium{
    height: 4.6em;
}

.navbar-items{
    padding: 1.2em;
    text-decoration: none;
    text-align: center;
    font-size: 1.5em;
    color: var(--grey);
}

.navbar-items:hover{
    cursor: pointer;
    color: var(--low-dark);
}

.navbar-items:focus{
    color: var(--low-dark);
}

.visibility{
    display: none;
}

.container-user-info{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 0.1em;
    padding-left: 2em;
    border-left: 1px solid var(--high-dark);
    height: 26px;
}

.container-user-info{
    font-size: 1.5em;
}

.button-logout{
    font-size: 0.65em;
    letter-spacing: 0.08em;
    background: inherit;
    border: none;
    padding: 0.1em;
}

/* NavBarPageNotFound */

`, "",{"version":3,"sources":["webpack://./src/components/navbar/style.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kDAAkD;IAClD,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA,uBAAuB","sourcesContent":["/* NavBar */\n\nheader{\n    width: 100%;\n    height: 6rem;\n    position: fixed;\n    z-index: 10;\n    box-shadow: 0px 0px 5px 1px var(--box-shadow-high);\n    background: var(--white);\n}\n\n.nav-bar{\n    height: 100%;\n    margin: auto;\n    max-width: 1680px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 10%;\n    font-size: 1rem;\n}\n\n.nav-links{\n    display: flex;\n}\n\n.navbar-logos{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\nheader .nav-bar ul{\n    height: 100%;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px;\n    padding: 0px;\n}\n\nheader .nav-bar li{\n    text-align: center;\n}\n\n.logo-sensedia, .logo-support-premium{\n    height: 3.2em;\n    margin-right: 4em;\n}\n\n.logo-support-premium{\n    height: 4.6em;\n}\n\n.navbar-items{\n    padding: 1.2em;\n    text-decoration: none;\n    text-align: center;\n    font-size: 1.5em;\n    color: var(--grey);\n}\n\n.navbar-items:hover{\n    cursor: pointer;\n    color: var(--low-dark);\n}\n\n.navbar-items:focus{\n    color: var(--low-dark);\n}\n\n.visibility{\n    display: none;\n}\n\n.container-user-info{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n    padding-bottom: 0.1em;\n    padding-left: 2em;\n    border-left: 1px solid var(--high-dark);\n    height: 26px;\n}\n\n.container-user-info{\n    font-size: 1.5em;\n}\n\n.button-logout{\n    font-size: 0.65em;\n    letter-spacing: 0.08em;\n    background: inherit;\n    border: none;\n    padding: 0.1em;\n}\n\n/* NavBarPageNotFound */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
